var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, property, html } from 'lit-element';
import styles from './styles';
export class Badge extends LitElement {
    constructor() {
        super(...arguments);
        this.BADGE_SUCCESS = 'badge badge-success';
        this.BADGE_WARNING = 'badge badge-warning';
        this.BADGE_DANGER = 'badge badge-danger';
        this.BADGE_DARK = 'badge badge-dark';
    }
}
Badge.styles = styles;
class TextNumberBadge extends Badge {
    render() {
        if (this.value === 'No info') {
            return html `<span class=${this.BADGE_DARK}>${this.value}</span>`;
        }
        else {
            return html `<span class=${this.getClass()}>${this.value}</span>`;
        }
    }
}
__decorate([
    property()
], TextNumberBadge.prototype, "value", void 0);
export class TextBadge extends TextNumberBadge {
}
__decorate([
    property()
], TextBadge.prototype, "value", void 0);
export class NumberBadge extends TextNumberBadge {
}
__decorate([
    property()
], NumberBadge.prototype, "value", void 0);
